import React from 'react';
import { CareProgressBadgeType, type CareProgressRowData } from '../types';
import moment from 'moment';
import CareProgressBadge from '../components/CareProgressBadge';

interface HistoryFormatterProps {
  id: string;
  rowData: CareProgressRowData[];
}

type EventDates = {
  inProgress: string[];
  completed: string[];
};

const HistoryFormatter: React.FC<HistoryFormatterProps> = ({ id, rowData }) => {
  const eventDates: EventDates = React.useMemo(() => {
    const dates: EventDates = {
      inProgress: [],
      completed: [],
    };
    rowData.forEach((event) => {
      const isInProgress =
        event.detail.status === CareProgressBadgeType.IN_PROGRESS;
      const isCompleted =
        event.detail.status === CareProgressBadgeType.COMPLETED;
      if (isInProgress) {
        dates.inProgress.push(moment(event.event_date).format('Do MMM YY'));
      } else if (isCompleted) {
        dates.completed.push(moment(event.event_date).format('Do MMM YY'));
      }
    });
    return dates;
  }, [rowData]);

  const renderedBadges: React.ReactElement = React.useMemo(() => {
    if (rowData.length === 0) {
      return (
        <CareProgressBadge
          id={id}
          type={CareProgressBadgeType.NO_DOCUMENT}
          columnName="history"
        />
      );
    }
    return (
      <>
        {eventDates.completed.length > 0 && (
          <CareProgressBadge
            id={id}
            type={CareProgressBadgeType.COMPLETED}
            completedDates={eventDates.completed}
            columnName="history"
          />
        )}
        {eventDates.inProgress.length > 0 && (
          <CareProgressBadge
            id={id}
            type={CareProgressBadgeType.IN_PROGRESS}
            startedDates={eventDates.inProgress}
            columnName="history"
          />
        )}
      </>
    );
  }, [eventDates, id, rowData]);
  return (
    <div className="d-flex gap-1 align-items-center">{renderedBadges}</div>
  );
};

export default HistoryFormatter;
